import SidebarContent from "./SidebarContent";

/**
 * Persistent left sidebar — desktop only (md+).
 * Mobile uses a Sheet drawer mounted in AppShell.
 */
export default function Sidebar({ refreshKey = 0 }) {
  return (
    <aside
      data-testid="sidebar"
      className="hidden md:flex w-64 shrink-0 flex-col border-r border-[#e5e7eb] bg-[#f7f8fa] p-5 h-screen sticky top-0"
    >
      <SidebarContent refreshKey={refreshKey} />
    </aside>
  );
}
